import { render } from "./histogram.vue?vue&type=template&id=5e8bbaf7&scoped=true"
import script from "./histogram.vue?vue&type=script&lang=js"
export * from "./histogram.vue?vue&type=script&lang=js"

import "./histogram.vue?vue&type=style&index=0&id=5e8bbaf7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8bbaf7"]])

export default __exports__